export const hebrew = {
  health: 'זה יופי להיות בריא',
  pension: 'פנסיה ביטוח ומה שחשוב',
  workingInSpace: 'עובדים בחלל',
  food: 'אוכלים, שותים ואוהבים את זה',
  allAround: 'כל המסביב',
}

